import { SelectionModel } from '@angular/cdk/collections'
import { ChangeDetectionStrategy, Component, Input, OnDestroy, OnInit } from '@angular/core'
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms'
import { AUTHORIZATION_STATUS, AuthorizationLikeItem } from '@mmx/shared'
import { Subject, takeUntil } from 'rxjs'

@Component({
  selector: 'mmx-prior-authorization-list',
  templateUrl: './prior-authorization-list.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: ServiceReviewListComponent,
      multi: true,
    },
  ],
  standalone: false,
})
export class ServiceReviewListComponent implements OnInit, OnDestroy, ControlValueAccessor {
  @Input()
  public serviceReviews: AuthorizationLikeItem[]

  public displayedColumns = [
    'select',
    'certificationNumber',
    'referenceNumber',
    'sourceApi',
    // 'serviceType',
    'requestType',
    'status',
    'procedures',
    'issueDate',
    'effectiveDate',
    'expirationDate',
  ]

  public selection = new SelectionModel<AuthorizationLikeItem>(true, [])

  private onDestroy$ = new Subject<void>()
  private onChange: (value: AuthorizationLikeItem[]) => void
  private onTouched: () => void

  public ngOnInit() {
    this.selection.changed
      .pipe(
        takeUntil(this.onDestroy$),
      )
      .subscribe(() => this.onChange(this.selection.selected))
  }

  public ngOnDestroy() {
    this.onDestroy$.next()
    this.onDestroy$.complete()
  }

  public toggleAllRows() {
    if (this.isAllSelected()) {
      this.selection.clear()
      return
    }

    this.selection.select(...this.serviceReviews)
  }

  public isAllSelected() {
    const numSelected = this.selection.selected.length
    const numRows = this.serviceReviews.length

    return numSelected === numRows
  }

  public writeValue(value: AuthorizationLikeItem[]) {
    this.selection.clear()
    this.selection.select(...(value || []))
  }

  public registerOnChange(onChange: (value: AuthorizationLikeItem[]) => void) {
    this.onChange = onChange
  }

  public registerOnTouched(onTouched: () => void) {
    this.onTouched = onTouched
  }

  public isAuthorizationStatus(status: string): status is AUTHORIZATION_STATUS {
    return Object.values(AUTHORIZATION_STATUS).includes(status as AUTHORIZATION_STATUS)
  }
}
